import { render } from "./Portfolio.vue?vue&type=template&id=62980d86&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=62980d86&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-62980d86"

export default script